@if (pickerService.open()) {
  <div class="picker-backdrop ph-no-capture" (click)="onBackdropClick($event)">
    <div class="picker" role="dialog" aria-modal="true" aria-labelledby="delegate-picker-title"
      [imFocusTrap]="true" [imFocusTrapInitial]="pickerInput" (keydown)="onKeydown($event)">

      <!-- Header -->
      <div class="picker-header">
        <h3 class="picker-title" id="delegate-picker-title">{{ pickerService.title() }}</h3>
        <paper-button class="picker-close" intent="ghost" shape="icon" size="sm" icon="x"
          [ariaLabel]="'shared.delegate_picker_dialog.close' | transloco" (click)="cancel()" />
      </div>

      @if (pickerService.mode() === 'delegate') {
        <p class="picker-description">{{ 'shared.delegate_picker_dialog.description' | transloco }}</p>
      }
      <!-- Search input -->
      <div class="picker-input-row">
        <paper-icon name="search" [size]="16" />
        <input
          #pickerInput
          type="text" class="ph-mask" [attr.aria-label]="'shared.delegate_picker_dialog.search_label' | transloco"
          role="combobox" aria-expanded="true" aria-controls="delegate-picker-results" aria-autocomplete="list"
          [attr.aria-activedescendant]="hasResults() ? 'delegate-person-' + selectedIndex() : null"
          [placeholder]="'shared.delegate_picker_dialog.search_by_name_or_email' | transloco"
          [value]="query()"
          (input)="onInput($event)"
          autocomplete="off"
        />
      </div>

      @if (pickerService.mode() === 'delegate') {
        <paper-segmented-control class="picker-filters" appearance="icon-label"
          [options]="filterOptions()" [value]="filter()"
          [ariaLabel]="'shared.delegate_picker_dialog.filter_label' | transloco"
          (valueChange)="setFilter($any($event))" />
      }
      <!-- Results -->
      <div class="picker-results" id="delegate-picker-results" #resultList role="listbox" [attr.aria-label]="'shared.delegate_picker_dialog.people' | transloco" [attr.aria-busy]="searching()">
        @if (failed() || (filter() === 'favourites' && groups.error())) {
          <div class="picker-status" role="status">{{ 'shared.delegate_picker_dialog.load_failed' | transloco }}</div>
        } @else if (searching() || (filter() === 'favourites' && groups.loading())) {
          <div class="picker-status">{{ 'shared.delegate_picker_dialog.searching' | transloco }}</div>
        } @else if (query().length > 0 && query().length < 2) {
          <div class="picker-status">{{ 'shared.delegate_picker_dialog.type_at_least_2_characters' | transloco }}</div>
        } @else if (!hasResults() && (pickerService.mode() === 'delegate' || query().length >= 2)) {
          <div class="picker-status">{{ 'shared.delegate_picker_dialog.no_one_found' | transloco }}</div>
        }

        @for (person of results(); track person.id; let i = $index) {
          <button
            class="picker-item"
            [id]="'delegate-person-' + i" role="option" [attr.aria-selected]="selectedIndex() === i"
            [class.selected]="selectedIndex() === i"
            (click)="selectPerson(person)"
            (mouseenter)="selectedIndex.set(i)"
            (focus)="selectedIndex.set(i)"
          >
            <div class="picker-avatar" [attr.data-initials]="getInitials(person.name)">
              @if (person.avatarUrl) {
                <img [src]="person.avatarUrl" [alt]="person.name" />
              }
            </div>
            <div class="picker-info">
              <span class="picker-name">{{ person.name }}</span>
              <span class="picker-email">{{ person.email }}</span>
              @if (person.currentSpaceName) {
                <span class="picker-location">{{ person.currentSpaceName }}@if (person.currentFloorName) {, {{ person.currentFloorName }}}</span>
              }
            </div>
            @if (groups.isFavourite(person.id)) {
              <paper-icon class="picker-favourite" name="heart" [size]="16" [attr.aria-label]="'shared.delegate_picker_dialog.favourite' | transloco" />
            }
            @if (person.status && person.status !== 'none') {
              <span class="picker-status-badge" [attr.data-status]="person.status">
                <paper-icon [name]="statusIcon(person.status)" [size]="12" />
                {{ statusLabel(person.status) }}
              </span>
            }
          </button>
        }
      </div>

      <!-- Footer -->
      <div class="picker-footer">
        <span class="picker-hint">
          <kbd>↵</kbd> {{ 'shared.delegate_picker_dialog.select' | transloco }} <kbd>↕</kbd> {{ 'shared.delegate_picker_dialog.navigate' | transloco }} <kbd>{{ 'shared.delegate_picker_dialog.esc' | transloco }}</kbd> {{ 'shared.delegate_picker_dialog.cancel' | transloco }}
        </span>
      </div>

    </div>
  </div>
}
